import '../../assets/scripts/main';
import './module.scss';

// for all page
import '../../components/app/header/header';
import '../../components/app/footer/footer';
import '../../components/app/menu/menu';
import '../../components/app/mobile-menu/mobile-menu';
import '../../components/sections/member-section/member-section';
import '../../components/sections/more-content/more-content';

import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/modules/pagination/pagination.scss';
import 'swiper/modules/navigation/navigation.scss';

import Dropdowns from '../../modules/dropdowns/dropdowns';
import { breakpoints } from '../../assets/styles/variables';

const { md } = { ...breakpoints }; // lg, md, sm, xs

const faqDropdowns = new Dropdowns({
	dropdownSelector: '.faq__item',
	contentSelector: '.faq__content',
});

faqDropdowns.init();

Swiper.use([Navigation, Pagination]);

// eslint-disable-next-line no-unused-vars
const quotesSlider = new Swiper('.quote-slider__wrapper', {
	spaceBetween: 20,
	slideClass: 'quote-slider__slide',

	navigation: {
		nextEl: '.quote-slider__button-next',
		prevEl: '.quote-slider__button-prev',
	},
	pagination: {
		el: '.quote-slider__pagination',
		clickable: true,
	},
	breakpoints: {
		[md]: {
			slidesPerView: 2,
		},
	},
});
// eslint-disable-next-line no-unused-vars
const videosSlider = new Swiper('.video-slider__wrapper', {
	spaceBetween: 15,
	slideClass: 'video-slider__slide',
	slidesPerView: 1,

	navigation: {
		nextEl: '.video-slider__button-next',
		prevEl: '.video-slider__button-prev',
	},
	pagination: {
		el: '.video-slider__pagination',
		clickable: true,
	},
});
